import { Button, Col, Text } from 'components';
import { theme } from 'lib';

const AddEvent = (props) => {
  function submit() {}

  return (
    <Col bg={theme.GREY_10} wid="100%">
      <Col bg={theme.GREY_10} ht="100%" wid="1140px" pad="50px 20px" center>
        <Col center>
          <Text size="30px" marg="0 0 50px" med>
            ADD EVENT
          </Text>
          <Col center>
            <Button text="Publish" website marg="20px 0 0" onClick={submit} action="addEvent" />
          </Col>
        </Col>
      </Col>
    </Col>
  );
};

export default AddEvent;
